import "intersection-observer";
import scrollama from "scrollama";
import gsap from "gsap";

export default class ScrollamaController {
    constructor() {
        this.scroller = new scrollama();
        this.headerScroller = new scrollama();
        this.hero = document.querySelector(".js-home-hero");
        this.heroBg = document.querySelector(".js-home-hero-bg");
        this.heroLogo = document.querySelector(".js-home-hero-logo");

        if (this.animatedElements) {
            this.init();
            this.animationsReset();
        }

        if (this.hero) {
            this.initHero();
        }

        this.animations = {

            "fade-from-top": {
                from: {
                    autoAlpha: 0,
                    duration: 1.2,
                    y: -100
                },
                to: {
                    autoAlpha: 1,
                    y: 0,
                    ease: "power3.out"
                }
            },

            "fade-from-bottom": {
                from: {
                    autoAlpha: 0,
                    duration: 1.2,
                    y: 50
                },
                to: {
                    autoAlpha: 1,
                    y: 0,
                    ease: "power3.out"
                }
            },

            "scale-up": {
                from: {
                    autoAlpha: 0,
                    duration: 2,
                    scale: 0.3
                },
                to: {
                    autoAlpha: 1,
                    scale: 1,
                    ease: "power3.out"
                }
            },

            "scale-down": {
                from: {
                    autoAlpha: 0,
                    duration: 2,
                    scale: 1.3
                },
                to: {
                    autoAlpha: 1,
                    scale: 1,
                    ease: "power3.out"
                }
            },
        };
    }

    initHero() {
        const self = this;
        function handleStepProgress(response) {
            self.heroLogo.style.opacity = 1.1 - response.progress * 1.7;
            gsap.to(self.heroBg, {
                y: response.progress * 200,
                duration: 0.01,
            });
        }


        this.headerScroller.setup({
            step: this.hero,
            progress: true,
            debug: false,
            offset: 0,
        })
            .onStepProgress(handleStepProgress);

    }

    get animatedElements() {
        return document.querySelectorAll(".js-animated-element");
    }

    init() {
        this.scroller
            .setup({
                step: this.animatedElements,
                // debug: true,
                offset: 0.85,
                once: true
            })
            .onStepProgress(response => {
                this.handleOnStepProgress(response);
            })
            .onStepEnter(response => {
                // this method calculates if its single od multiple item in the row.
                // If there is more then one it will trigger them with delay (setTimeout)
                // -> 150ms * increment (increment is index in the row -> 0, 1, 2, 3, ...)
                this.itemsInRowCalculation(response);
            });

        // setup resize event
        // resize();
        // window.addEventListener('resize', resize);
    }

    itemsInRowCalculation(response) {
        const indexes = [];
        for (let elem of this.animatedElements) {

            if (elem.getBoundingClientRect().top === response.element.getBoundingClientRect().top) {
                indexes.push(elem.dataset.scrollamaIndex);
            }
        }

        const sum = (indexes[indexes.length - 1] - indexes[0]);

        for (let i = 0; i <= sum; i++) {
            if (indexes[i] === response.element.dataset.scrollamaIndex) {
                this.handleOnStepEnter(response, i);
            }
        }
    }

    handleOnStepProgress(response) {
        response.element.style.opacity = 1 - response.progress;
    }

    handleOnStepEnter(response, increment) {
        if (response.element.hasAttribute("data-animation")) {

            response.element.classList.add("is-animated");

            //"data-animation" is set, use animation type from value
            const animationType = response.element.getAttribute("data-animation");

            setTimeout(() => {
                gsap.fromTo(
                    response.element, this.animations[animationType].from, this.animations[animationType].to,
                );
            }, 150 * increment);
        }

        // fallback if "data-animation" attribute not set
        else {
            response.element.classList.add("is-animated");

            gsap.fromTo(
                response.element,
                {
                    autoAlpha: 0,
                    duration: 0.3,
                    y: 20
                },
                {
                    autoAlpha: 1,
                    y: 0,
                    ease: "power3.out"
                }
            );
        }
    }

    animationsReset() {
        for (const element of this.animatedElements) {
            gsap.set(element, {
                autoAlpha: 0
            });
        }
    }
}


